import React, { useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Breadcrumb } from '@fikasio/react-ui-components';
import ReactGA from 'react-ga4';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import OrganizationView from 'components/organizations/OrganizationView';
import BasePage from 'components/UI/BasePage';
import { useGetOrganizationsQuery } from 'services/organizations/api';
import links, { matchesLinkKey } from 'utils/links';
import { spaLinkProps } from 'utils/spaLink';

const OrganizationPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { slug } = useParams<{ slug: string; }>();
  const { data: organizations } = useGetOrganizationsQuery();
  const organization = organizations && organizations.find(item => matchesLinkKey(item, slug));

  useEffect(() => {
    ReactGA.send({
      hitType: 'pageview',
      page: location.pathname,
    });
  }, []);

  return (
    <>
      <Helmet>
        <title>{`${t('organizations')}${organization?.name ? ` - ${organization.name}` : ''}`}</title>
      </Helmet>
      <BasePage>
        <Breadcrumb
          items={[
            { ...spaLinkProps(links.paths.home, navigate), label: t('home') },
            { ...spaLinkProps(links.paths.organizations, navigate), label: t('organizations') },
            { label: organization?.name ?? '' },
          ]}
        />
        <h4>{ organization?.name }</h4>
        <br />
        {
          organization && (
            <OrganizationView
              organization={organization}
            />
          )
        }
      </BasePage>
    </>
  );
};

export default OrganizationPage;
